module.exports = __webpack_public_path__ + "img/Profesional_de_Confianza.96552cd2.svg";